import CancellableHelper from "@/requests/CancellableHelper";
import { WorkFlowModelResponse } from "@/models/api/administration/workflow/WorkFlowModel";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { WorkFlowItemModel } from "@/models/api/administration/workflow/WorkFlowItemModel";
import { WorkFlowDataModel } from "@/models/api/administration/workflow/WorkFlowDataModel";
import { WorkFlowEdit } from "@/models/api/administration/workflow/WorkFlowEdit";

//#region Routes
export const URL_GET_WORK_FLOW_LIST = "/WorkFlow/GetWorkFlowList";
export const URL_GET_WORK_FLOW_DATA_LIST = "/WorkFlow/${WorkFlowId}/GetWorkFlowDataList";
export const URL_GET_WORK_FLOW_ITEM_LIST = "/WorkFlow/${WorkFlowId}/GetWorkFlowItemList";
export const URL_POST_EDIT_WORK_FLOW = "/WorkFlow/${WorkFlowId}/EditWorkFlow";
export const URL_POST_EDIT_WORK_FLOW_ITEM = "/WorkFlow/${WorkFlowItemId}/EditWorkFlowItem";
export const URL_POST_CREATE_WORK_FLOW_FROM_PROTOTYPE = "/WorkFlow/CreateWorkFlowFromPrototype";
//#endregion

const _getWorkFlowList = new CancellableHelper<WorkFlowModelResponse>(URL_GET_WORK_FLOW_LIST, WorkFlowModelResponse);
_getWorkFlowList.jsonSerializer = true;
export const getWorkFlowList = async (genericTableRequest: GenericTableRequest): Promise<WorkFlowModelResponse> => {
  return await _getWorkFlowList.get(genericTableRequest);
};

const _getWorkFlowDataList = new CancellableHelper<Array<WorkFlowDataModel>>(
  URL_GET_WORK_FLOW_DATA_LIST,
  WorkFlowDataModel
);
export const getWorkFlowDataList = async (workFlowId: number): Promise<Array<WorkFlowDataModel>> => {
  return await _getWorkFlowDataList.get({ WorkFlowId: workFlowId });
};

const _getWorkFlowItemList = new CancellableHelper<Array<WorkFlowItemModel>>(
  URL_GET_WORK_FLOW_ITEM_LIST,
  WorkFlowItemModel
);
export const getWorkFlowItemList = async (workFlowId: number): Promise<Array<WorkFlowItemModel>> => {
  return await _getWorkFlowItemList.get({ WorkFlowId: workFlowId });
};

const _postEditWorkFlow = new CancellableHelper<null>(URL_POST_EDIT_WORK_FLOW, null, true);
export const postEditWorkFlow = async (workFlowId: number, workFlow: WorkFlowEdit): Promise<null> => {
  return await _postEditWorkFlow.post({ WorkFlowId: workFlowId }, workFlow);
};

const _postEditWorkFlowItem = new CancellableHelper<null>(URL_POST_EDIT_WORK_FLOW_ITEM, null, true);
export const postEditWorkFlowItem = async (workFlowItemId: number, state: number): Promise<null> => {
  return await _postEditWorkFlowItem.post({
    WorkFlowItemId: workFlowItemId,
    state: state,
  });
};

const _postCreateWorkFlowFromPrototype = new CancellableHelper<null>(
  URL_POST_CREATE_WORK_FLOW_FROM_PROTOTYPE,
  null,
  true
);
export const postCreateWorkFlowFromPrototype = async (prototypeName: string, bindingId: string): Promise<null> => {
  return await _postCreateWorkFlowFromPrototype.post({
    prototypeName: prototypeName,
    bindingId: bindingId,
  });
};
